import React, {useState, useEffect} from 'react';
import {extract} from "../utils";
import {Galleria} from "primereact/galleria";
import _ from "lodash";

export const Gallery = ({env, value, render, thumbnail = null, activeIndex= null, onItemChange = undefined, extraConfig, ...rest}) => {
    const responsiveOptions = [
        {
            breakpoint: '1024px',
            numVisible: 5
        },
        {
            breakpoint: '768px',
            numVisible: 3
        },
        {
            breakpoint: '560px',
            numVisible: 1
        }
    ];
    const [useActiveIndex, setUseActiveIndex] = useState(0)
    useEffect( () => {
        if(activeIndex !== null)setUseActiveIndex(activeIndex)
    }, [activeIndex])
    const {showEmpty = false, skipOnSingle = false, emptyMsg = ''} = extraConfig
    const useValue = _.flattenDeep(value || []).filter( el => showEmpty || !!el)
    console.log('GALLERY VIEWER', useValue, value, activeIndex)
    const has2 = useValue?.length > 1
    if(skipOnSingle && !has2){
        return useValue.length ? render(useValue[0]) : emptyMsg
    }
    return <div style={env === 'table' ? {padding: '20px'} : {}}>
        <Galleria value={useValue} item={item => render(item)} activeIndex={useActiveIndex} onItemChange={(e) => onItemChange ? onItemChange(e.index) : setUseActiveIndex(e.index)} thumbnail={item => thumbnail ? thumbnail(item) : render(item, {thumbnail:true})}
                  {...extract( {header: undefined, footer: undefined, style: undefined, className: undefined,
                  circular: undefined, autoPlay: undefined, transitionInterval: undefined, numVisible: undefined, responsiveOptions: undefined,
                  thumbnailsPosition: undefined, indicatorsPosition: undefined, verticalThumbnailViewPortHeight: undefined,
                  showItemNavigators: env !== 'table' && has2, showThumbnailNavigators: has2 ? false : undefined, showThumbnails: env === 'table' || !has2 ? false : undefined, showIndicators:  env === 'table' && has2, showIndicatorsOnItem: undefined,
                  showItemNavigatorsOnHover: undefined, changeItemOnIndicatorHover: undefined, fullscreen: undefined, baseZIndex: undefined, transitionOptions: undefined}, extraConfig)}/>
        </div>
}